// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --background: 215 60% 98%;
  --foreground: 221 60% 10%;
  --muted: 213 44% 93%;
  --muted-foreground: 220 12% 42%;
  --popover: 0 0% 100%;
  --popover-foreground: 221 60% 10%;
  --card: 0 0% 100%;
  --card-foreground: 221 60% 10%;
  --border: 215 31% 88%;
  --input: 215 31% 88%;
  --primary: 221 71% 20%;
  --primary-foreground: 210 40% 98%;
  --secondary: 210 64% 52%;
  --secondary-foreground: 210 40% 98%;
  --accent: 197 72% 67%;
  --accent-foreground: 221 71% 20%;
  --destructive: 0 84% 56%;
  --destructive-foreground: 210 40% 98%;
  --ring: 210 64% 52%;
  --radius: 0.75rem;
  --font-sans: 'Plus Jakarta Sans', 'Inter', 'SF Pro Display', 'Segoe UI', sans-serif;
  --text-display: clamp(2.75rem, 4vw, 4.25rem);
  --text-heading: clamp(2rem, 2.6vw, 3rem);
  --text-title: clamp(1.35rem, 1.5vw, 1.75rem);
  --text-body: clamp(1rem, 1vw, 1.15rem);
  --text-label: clamp(0.85rem, 0.9vw, 0.95rem);
}

.dark {
  --background: 221 60% 8%;
  --foreground: 210 40% 96%;
  --muted: 220 30% 16%;
  --muted-foreground: 214 18% 68%;
  --popover: 221 60% 8%;
  --popover-foreground: 210 40% 96%;
  --card: 221 60% 10%;
  --card-foreground: 210 40% 96%;
  --border: 219 34% 24%;
  --input: 219 34% 24%;
  --primary: 210 64% 52%;
  --primary-foreground: 221 71% 10%;
  --secondary: 197 72% 67%;
  --secondary-foreground: 221 71% 18%;
  --accent: 221 71% 24%;
  --accent-foreground: 210 40% 96%;
  --destructive: 0 72% 42%;
  --destructive-foreground: 0 0% 100%;
  --ring: 210 64% 52%;
}

body {
  background-color: hsl(var(--background));
  color: hsl(var(--foreground));
  font-family: var(--font-sans);
}

h1,
.text-display {
  font-size: var(--text-display);
  line-height: 1.1;
  letter-spacing: -0.04em;
  font-weight: 600;
}

h2,
.text-heading {
  font-size: var(--text-heading);
  line-height: 1.15;
  letter-spacing: -0.03em;
  font-weight: 600;
}

h3,
.text-title {
  font-size: var(--text-title);
  line-height: 1.25;
  font-weight: 600;
}

body,
p,
.text-body {
  font-size: var(--text-body);
  line-height: 1.6;
}

small,
.text-label {
  font-size: var(--text-label);
  letter-spacing: 0.01em;
}
`, "",{"version":3,"sources":["webpack://./../../libs/ui/src/lib/theme.css"],"names":[],"mappings":"AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,oBAAoB;EACpB,+BAA+B;EAC/B,oBAAoB;EACpB,iCAAiC;EACjC,iBAAiB;EACjB,8BAA8B;EAC9B,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;EACtB,iCAAiC;EACjC,wBAAwB;EACxB,mCAAmC;EACnC,qBAAqB;EACrB,gCAAgC;EAChC,wBAAwB;EACxB,qCAAqC;EACrC,mBAAmB;EACnB,iBAAiB;EACjB,mFAAmF;EACnF,4CAA4C;EAC5C,wCAAwC;EACxC,4CAA4C;EAC5C,sCAAsC;EACtC,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,oBAAoB;EACpB,+BAA+B;EAC/B,qBAAqB;EACrB,iCAAiC;EACjC,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;EACtB,iCAAiC;EACjC,wBAAwB;EACxB,mCAAmC;EACnC,qBAAqB;EACrB,gCAAgC;EAChC,wBAAwB;EACxB,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;;EAEE,8BAA8B;EAC9B,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;EAEE,8BAA8B;EAC9B,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;EAEE,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;EAGE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;;EAEE,4BAA4B;EAC5B,sBAAsB;AACxB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap');\n\n:root {\n  --background: 215 60% 98%;\n  --foreground: 221 60% 10%;\n  --muted: 213 44% 93%;\n  --muted-foreground: 220 12% 42%;\n  --popover: 0 0% 100%;\n  --popover-foreground: 221 60% 10%;\n  --card: 0 0% 100%;\n  --card-foreground: 221 60% 10%;\n  --border: 215 31% 88%;\n  --input: 215 31% 88%;\n  --primary: 221 71% 20%;\n  --primary-foreground: 210 40% 98%;\n  --secondary: 210 64% 52%;\n  --secondary-foreground: 210 40% 98%;\n  --accent: 197 72% 67%;\n  --accent-foreground: 221 71% 20%;\n  --destructive: 0 84% 56%;\n  --destructive-foreground: 210 40% 98%;\n  --ring: 210 64% 52%;\n  --radius: 0.75rem;\n  --font-sans: 'Plus Jakarta Sans', 'Inter', 'SF Pro Display', 'Segoe UI', sans-serif;\n  --text-display: clamp(2.75rem, 4vw, 4.25rem);\n  --text-heading: clamp(2rem, 2.6vw, 3rem);\n  --text-title: clamp(1.35rem, 1.5vw, 1.75rem);\n  --text-body: clamp(1rem, 1vw, 1.15rem);\n  --text-label: clamp(0.85rem, 0.9vw, 0.95rem);\n}\n\n.dark {\n  --background: 221 60% 8%;\n  --foreground: 210 40% 96%;\n  --muted: 220 30% 16%;\n  --muted-foreground: 214 18% 68%;\n  --popover: 221 60% 8%;\n  --popover-foreground: 210 40% 96%;\n  --card: 221 60% 10%;\n  --card-foreground: 210 40% 96%;\n  --border: 219 34% 24%;\n  --input: 219 34% 24%;\n  --primary: 210 64% 52%;\n  --primary-foreground: 221 71% 10%;\n  --secondary: 197 72% 67%;\n  --secondary-foreground: 221 71% 18%;\n  --accent: 221 71% 24%;\n  --accent-foreground: 210 40% 96%;\n  --destructive: 0 72% 42%;\n  --destructive-foreground: 0 0% 100%;\n  --ring: 210 64% 52%;\n}\n\nbody {\n  background-color: hsl(var(--background));\n  color: hsl(var(--foreground));\n  font-family: var(--font-sans);\n}\n\nh1,\n.text-display {\n  font-size: var(--text-display);\n  line-height: 1.1;\n  letter-spacing: -0.04em;\n  font-weight: 600;\n}\n\nh2,\n.text-heading {\n  font-size: var(--text-heading);\n  line-height: 1.15;\n  letter-spacing: -0.03em;\n  font-weight: 600;\n}\n\nh3,\n.text-title {\n  font-size: var(--text-title);\n  line-height: 1.25;\n  font-weight: 600;\n}\n\nbody,\np,\n.text-body {\n  font-size: var(--text-body);\n  line-height: 1.6;\n}\n\nsmall,\n.text-label {\n  font-size: var(--text-label);\n  letter-spacing: 0.01em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
